import {
  useCreatePresetMutationApi,
  useGetSinglePresetApi,
  useUpdatePresetMutationApi,
} from '@aibees/shared/api';

export function useCreateOrUpdatePresetMutation<T>(
  presetType: string,
  allowDuplication: boolean = false
) {
  const { data, refetch } = useGetSinglePresetApi<T>({ type: presetType });
  const apiCreate = useCreatePresetMutationApi<T>(allowDuplication);
  const apiUpdate = useUpdatePresetMutationApi<T>(data?.id ?? '', 1000);
  const api = data ? apiUpdate : apiCreate;

  const mutateAsync = (value: T, type?: string, name?: string) => {
    return api.mutateAsync({
      ...data,
      name: name ?? data?.name ?? '',
      type: type ?? data?.type ?? '',
      value,
      allowDuplication: false,
    });
  };

  return { mutateAsync, refetch, data };
}
